export default {
	titleSave: 'Uložení šablony',
	titleRead: 'Načtení ze šablony',
	deleteTemplate: 'Opravdu chcete odstranit šablonu?',
	templateTable: 'Seznam uložených šablon',
	templateName: 'Název šablony',
	existingTemplateNameWarning: 'Šablona s tímto názvem již existuje, přejete si původní šablonu nahradit?',
	showAll: 'Zobrazit vše',
	total: 'Celkem',
};
